import React, {useCallback, useRef, useState} from "react";
import {createUUId} from "../../../../core/services/utils/utils";
import {Dialog, DialogActions, DialogContent, DialogTitle, Divider} from "@mui/material";
import {Row} from "reactstrap";
import Button from "../../base/button/button";
import ConnectToPrinterHub from "../../app-specific/connect-to-printer-hub";

const ConnectToPrinterHubDialog = ({
                                       open,
                                       onClose,
                                       onConnect,
                                   }) => {
    const [submitting, setSubmitting] = useState(false);
    const formIdRef = useRef(createUUId());

    /**
     * Connect to printer hub and close dialog.
     * @type {(function(*): void)|*}
     */
    const onPrintHubConnected = useCallback((hub) => {
        onConnect(hub);
        onClose();
    }, [onClose, onConnect])

    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                maxWidth={'sm'}
                fullWidth
            >
                <DialogTitle>
                    Connect to printer hub
                </DialogTitle>
                <DialogContent>
                    <ConnectToPrinterHub
                        onConnect={onPrintHubConnected}
                        formId={formIdRef.current}
                        submitting={submitting}
                        setSubmitting={setSubmitting}
                    />
                </DialogContent>
                <DialogActions className={'p-0 m-0'}>
                    <Row className={'w-100 no-gutters'}>
                        <Divider className='divider'/>
                        <Row className='no-gutters justify-content-end align-items-start w-100'>
                            <Button
                                disabled={!open || submitting}
                                variant={'dialog'}
                                color={'primary'}
                                type={'submit'}
                                form={formIdRef.current}
                                borderRadius={'8px 0 8px 0'}
                            >
                                {submitting ? "Connecting..." : "Connect"}
                            </Button>
                        </Row>
                    </Row>
                </DialogActions>
            </Dialog>
        </>
    )
}
export default ConnectToPrinterHubDialog;
